











import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'OrderViewReport'
})
export default class extends Vue {
  @Prop({
    required: true,
    default: () => {
      return ''
    }
  }) report!: '';

  @Prop({
    type: Boolean,
    default: () => {
      return ''
    }
  }) listLoading;

  @Prop({
    type: String,
    default: () => {
      return ''
    }
  }) label

  downloadHtml() {
    const blob = new Blob([this.report], { type: 'text/html' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = this.label
    link.click()
    URL.revokeObjectURL(link.href)
  }
}
